// extracted by mini-css-extract-plugin
export var actionButton = "_k1-t";
export var buttonContainer = "_k1-0";
export var buttonContainer2 = "_k1-1";
export var buttonSection = "_k1-2";
export var details = "_k1-3";
export var dropdownItem = "_k1-5";
export var dropdownItemsContainer = "_k1-4";
export var fileInput = "_k1-r";
export var headerButton = "_k1-6";
export var icon = "_k1-7";
export var input = "_k1-8";
export var macroListItem = "_k1-9";
export var mainContent = "_k1-a";
export var microText = "_k1-b";
export var modal = "_k1-w";
export var optionsButton = "_k1-c";
export var paperclip = "_k1-s";
export var pillContent = "_k1-d";
export var preview = "_k1-e";
export var preview2 = "_k1-f";
export var quillEditor = "_k1-q";
export var selectedMacro = "_k1-g";
export var sidebar = "_k1-h";
export var sidebarHeader = "_k1-j";
export var sidebarList = "_k1-i";
export var sidebarListItem = "_k1-k";
export var sidebarSearch = "_k1-l";
export var snoozeDurationWrapper = "_k1-v";
export var statusPillContainer = "_k1-m";
export var tagsContainer = "_k1-n";
export var unselectedMacro = "_k1-o";
export var variable = "_k1-u";
export var wrapper = "_k1-p";